<template>
  <div class="column">
    <div class="columns">
      <div class="column">
        <div class="list-view has-background-white p-3 is-border-radius-sm card-tab-details">
          <table-toolbar searchPlaceHolder="Search Members" :toolbarOpts="tableColOpts.toolBar"
            @handleAction="handleAction" />
          <data-table :apiMode="true" :tableOpts="tableColOpts" :loadData="loadData" @cell-clicked="handleAction"
            :key="refreshTable" />
        </div>
      </div>
    </div>
  </div>

  <o-modal v-if="showAddMemberModal" :active="showAddMemberModal" :canCancel="false"
    :class="editMode ? 'modal-xs' : 'modal-md'">
    <div class="modal-card">
      <header class="modal-card-head is-borderless">
        <h3 class="card-header-title p-0 has-text-black-bis">
          {{ !editMode ? 'Select Users' : 'Edit User' }}
        </h3>
      </header>
      <section class="modal-card-body is-visible has-text-black-bis card-tab-details" v-if="!editMode">
        <div class="column">
          <div class="columns is-align-items-center">
            <div class="column is-narrow">
              <h3 class="is-size-3 has-text-weight-semibold has-text-black-bis line-height">Add members as :</h3>
            </div>
            <div class="column">
              <mf-multi-select v-model="permissions" :options="userPermissionGroups" :closeOnSelect="true" label="label"
                track-by="value" class="overflow-visible pendo-permission-select" :multiple="false" :allow-empty="false"
                :taggable="false" @input="setPermission">
              </mf-multi-select>
            </div>
            <div class="is-divider-vertical"></div>
            <div class="column">
              <search-bar :shouldEmit="true" @search="searchModalData" placeholder="Search">
              </search-bar>
            </div>
          </div>
        </div>
        <data-table :apiMode="true" :tableOpts="userImportTableCols" :loadData="nonProjectUsers"
          @checkbox-toggled="setSelectedRows" :key="refreshModalTable" />
      </section>
      <section class="modal-card-body is-visible has-text-black-bis px-2" v-else>
        <div class="column">
          <div class="columns">
            <div class="column ">
              <h3 class="is-size-3 has-text-weight-semibold has-text-black-bis line-height">Name</h3>
              <p class="line-height">{{ rowToEdit.name }}</p>
            </div>
            <div class="column">
              <h3 class="is-size-3 has-text-weight-semibold has-text-black-bis line-height">Admin</h3>
                <span>
                  <o-checkbox class="pl-0 py-0" v-model="rowToEdit.isAdmin" @update:model-value="setPermissionGroup">
                  </o-checkbox>
                </span>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full">
              <h3 class="is-size-3 has-text-weight-semibold has-text-black-bis line-height">Role</h3>
              <mf-multi-select v-model="selectedRole" :options="roleOptions" :closeOnSelect="true" label="type"
                track-by="value" class="overflow-visible pendo-permission-select" :multiple="false" :allow-empty="false"
                :taggable="false">
              </mf-multi-select>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot is-justify-content-flex-end">
        <button class="button is-outlined" @click="
          showAddMemberModal = false;
        editMode = false;
        modalSearchVal = ''
          ">
          Cancel
        </button>
        <button class="button has-background-black-bis" :disabled="editMode ? false : $_.isEmpty(selectedUsersToAdd)"
          @click="handleAddUpdate">
          {{ editMode ? "Update" : "Add" }}
        </button>
      </footer>
    </div>
    <o-loading :active="isLoading" :full-page="false" />
  </o-modal>
  <activity-log
      :id="activityDetail.id"
      :projectId="activityDetail.projectId"
      :isActive="isActivityLogOpen"
      :orderName="activityDetail.orderName"
      @update:isActive="isActivityLogOpen = false"
      :type = "module"
    ></activity-log>
</template>
<script>
import { computed, onBeforeMount, reactive, toRefs } from "vue";
import { useStore } from 'vuex';
import DataTable from "@/components/table-fields/DataTable.vue";
import TableToolbar from "@/components/table-fields/TableToolbar.vue";
import projectTeamCols from "@/components/table-cols/projectTeamCols.js";
import TableGutter from "@/components/TableGutter.vue";
import Projects from '@/models/Projects';
import SearchBar from '@/components/SearchBar.vue';
import Users from '@/models/Users';
import { assign, each, find, findIndex, isEmpty, map, set } from 'lodash';
import { useToast } from "vue-toastification";
import { DialogProgrammatic } from "@/components/Dialog";
import ActivityLog from '@/components/ActivityLog.vue';

export default {
  name: "Project Team",
  components: {
    DataTable,
    TableToolbar,
    TableGutter,
    SearchBar,
    ActivityLog
  },
  props: {
    rowData: Object,
  },
  setup(props) {
    const toast = useToast();

    const data = reactive({
      tableColOpts: projectTeamCols,
      isLoading: false,
      showAddMemberModal: false,
      editMode: false,
      selectedUsersToAdd: [],
      permissions: { label: 'User', value: 'User', id: '' },
      refreshTable: 0,
      rowToEdit: {},
      selectedRole: {},
      searchVal: '',
      modalSearchVal: '',
      refreshModalTable: 0,
      activityDetail: {
        id: '',
        projectId: '',
        orderName: '',
      },
      isActivityLogOpen: false,
    });

    const roleOptions = [
      {
        type: 'Assistant Project Manager',
        value: 'assistant-project-manager',
      }, {
        type: 'Coordinator',
        value: 'coordinator',
      }, {
        type: 'Detailer',
        value: 'detailer',
      }, {
        type: 'Estimator',
        value: 'estimator',
      }, {
        type: 'Field Super',
        value: 'field-super',
      }, {
        type: 'Inventory Manager',
        value: 'inventory-manager',
      }, {
        type: 'Partner',
        value: 'partner',
      }, {
        type: 'Procurement Manager',
        value: 'procurement-manager',
      }, {
        type: 'QA',
        value: 'qa',
      }, {
        type: 'Project Engineer',
        value: 'project-engineer',
      }, {
        type: 'Project Manager',
        value: 'project-manager',
      }, {
        type: 'Project Executive',
        value: 'project-executive',
      }, {
        type: 'Shipping Manager',
        value: 'shipping-manager',
      }, {
        type: 'Shop Super',
        value: 'shop-super',
      }
    ]

    const userImportTableCols = {
      defaultSortField: 'name',
      defaultSortOrder: 'asc',
      isCheckable: true,
      fields: [
        {
          title: 'Name',
          name: 'fullName',
          width: '200px',
          id: 'name',
          sortField: 'firstName',
          prop: 'firstName',
          defaultVisible: true,
        },
        {
          title: 'Email',
          name: 'email',
          width: '192px',
          id: 'email',
          sortField: 'email',
          prop: 'email',
          defaultVisible: true,
        },
        {
          name: 'companyName',
          title: 'Company',
          id: 'company',
          width: '192px',
          sortField: 'company',
          prop: 'companyName',
          defaultVisible: true,
        },
        {
          name: 'office',
          sortField: 'office',
          title: 'OFFICE',
          id: 'office',
          width: '192px',
          prop: 'office',
          defaultVisible: true,
        },
        {
          name: 'status',
          title: 'Status',
          id: 'status',
          width: '156px',
          prop: 'activated',
          defaultVisible: true,
          formatter(value) {
            return value ? 'Active' : 'Inactive';
          },
        }
      ],
    }

    const store = useStore();

    const loadData = async (commonParam, e) => {
      // const showArchived = typeof this.queryParams.selectedList === 'boolean'
      //   ? this.queryParams.selectedList : false;
      await store.getters.userPromise;
      const result = await Projects.listProjectUsers({
        ...commonParam,
        sort: commonParam.sort[0].direction === 'asc' ? commonParam.sort[0].sortField : `-${commonParam.sort[0].sortField}`,
        project_id: props.rowData._id,
        alreadyInvited: true,
        searchText: data.searchVal,
      });
      return result
    }

    const nonProjectUsers = async (commonParam) => {
      const queryParams = {
        ...commonParam,
        sort: { [commonParam.sort[0].sortField]: commonParam.sort[0].direction === 'asc' ? 1 : -1 },
        project_id: props.rowData._id,
        alreadyInvited: false,
        searchText: data.modalSearchVal
      };
      let result = '';
      if (store.state.projectViewOnlyMember) {
        await store.getters.userPromise;
        queryParams.user = store.state.userData;
        result = await Users.listProjectViewUsers(queryParams);
      } else {
        result = await Projects.nonProjectUsers(queryParams);
      }
      return { data: result.items, total: result.totalCount };
    }

    const setModalActive = (key, val) => {
      data[key] = val;
    };

    const setEdit = (row) => {
      data.editMode = true;
      data.rowToEdit = row
      data.selectedRole = find(roleOptions, (r) => r.value === row.memberRole)
      setModalActive('showAddMemberModal', true)
    }

    const searchData = (val) => {
      if ((!isEmpty(data.searchVal) && isEmpty(val)) || (!isEmpty(val) && data.searchVal !== val)) {
        data.searchVal = val
        data.refreshTable++;
      }
    }

    const handleAction = async (action) => {
      if (action === 'addNew') {
        action = { type: '' }
        action.type = 'addNew'
      }
      if (action === 'activity') {
        action = {type: ''}
        action.type = 'activity'
      }
      const actionMapper = {
        addNew: () => setModalActive('showAddMemberModal', true),
        activity: () => {
          data.activityDetail = {
            id: props.rowData._id,
            projectId: props.rowData._id,
            orderName: props.rowData.name,
          };
          data.isActivityLogOpen = true;
        },
        edit: (row) =>  setEdit(row),
        delete: (row) => removeUser(row),
        search: (val) => searchData(val)
      }
      try {
        actionMapper[action.type]?.(action.data)
        data.isLoading = true
      } catch (e) {
        console.error('Error: ', e)
      } finally {
        data.isLoading = false
      }
    }

    const setSelectedRows = (rows) => {
      data.selectedUsersToAdd = rows
    }

    const userPermissionGroups = computed(() => {
      const permissionGroups = [];

      const lockedGroup = find(
        store.state.availablePermissionGroups,
        (grp) => grp.isLocked && grp.name === 'Project Admin',
      );
      ['User', 'Project Admin'].forEach((permission) => {
        const permissionId = permission === 'Project Admin' ? lockedGroup._id : '';
        permissionGroups.push({
          label: permission,
          value: permission,
          id: permissionId,
        });
      });
      return permissionGroups;
    })

    const handleAddUpdate = async () => {
      data.isLoading = true
      try {
        if (data.editMode) {
          data.rowToEdit.projectId = props.rowData._id;
          data.rowToEdit.memberRole = data.selectedRole.value
          data.rowToEdit.project = { _id: props.rowData._id }
          await Projects.updateRole(data.rowToEdit);
          store.dispatch('getUserData');
          await store.getters.userPromise;
          const updatedProject = await Projects.getOne(props.rowData._id);
          const updateFields = ['projects', 'projectsAndGI', '_projects', '_projectsAndGI'];
          const { queryParams } = store.state
          updateFields.forEach((key) => {
            const projectIdx = findIndex(queryParams[key], { _id: props.rowData._id });
            if (projectIdx > -1) {
              queryParams[key][projectIdx] = updatedProject;
              store.commit('setQueryParams', { [key]: queryParams[key] });
            }
          });
        } else {
          const params = {
            projectId: props.rowData._id,
            emails: [],
            title: 'User', // Remove  while swtiching to new permission system.
            permissionGroups: '',
          }
          each(data.selectedUsersToAdd, (val) => {
            params.emails.push(val.email);
          });
          if (store.state.projectViewOnlyMember) {
            assign(params, {
              project: {
                _id: props.rowData._id,
                name: props.rowData.name,
              },
            });
            await Users.inviteViewUsersToProject(params);
          } else {
            if (data.permissions.label === 'Project Admin') {
              params.title = 'Project Admin';
              params.permissionGroups = data.permissions.id
            }
            await Projects.addUserToProject(params);
          }
        }
      } catch (e) {
        console.log('Error: ', e)
      } finally {
        data.isLoading = false
        setModalActive('showAddMemberModal', false)
        data.permissions = { label: 'User', value: 'User', id: '' }
        data.selectedUsersToAdd = {}
        data.selectedRole = {}
        data.rowToEdit = {}
        data.editMode = false
        data.refreshTable++;
      }
    }

    const setPermissionGroup = (val) => {
      const lockedGroup = find(
        store.state.availablePermissionGroups,
        (grp) => grp.isLocked && grp.name === 'Project Admin',
      );
      if (!isEmpty(lockedGroup._id) && val === true) {
        set(data.rowToEdit, 'permissionGroups', [lockedGroup._id]);
        set(data.rowToEdit, 'role', 'Project Admin');
      } else {
        set(data.rowToEdit, 'role', 'User');
      }
    }

    const removeUser = async (userData) => {
      const projectId = props.rowData._id;
      const user = store.state.userData;
      const userCompanyIds = map(userData.multiCompanies, (comp) => comp.company._id.toString());
      if (userData._id.toString() === user._id.toString()) {
        toast.error('You cannot remove yourself')
        return false;
      } else if (!store.state.projectViewOnlyMember
        && !userCompanyIds.includes(user.company.toString())) {
        toast.error('You cannot remove another company\'s member')
      } else {
        let msg = '';
        if (store.state.projectViewOnlyMember) msg = 'Deleting this user will block their access to this project. Continue?';
        else msg = 'The member will be deleted, and their Orders assigned to you.';

        DialogProgrammatic.confirm({
          title: 'Delete Member',
          message: msg,
          okButton: "Delete",
          cancelButton: "Cancel",
          onConfirm: async () => {
            try {
              data.isLoading = true
              if (store.state.projectViewOnlyMember) {
                await Users.removeViewUser({
                  id: projectId,
                  userId: userData._id,
                });
              } else {
                await Projects.deleteUser({
                  id: projectId,
                  userId: userData._id,
                });
              }
              toast.success('User Removed')
            } catch (e) {
              console.log('Error: ', e)
            } finally {
              data.isLoading = false
              data.refreshTable++;
            }
          },
        });
      }
    }

    onBeforeMount(async() => {
      data.project = _.cloneDeep(props.rowData)
      await store.getters.userPromise;
    })

    const searchModalData = (val) => {
      if ((!isEmpty(data.modalSearchVal) && isEmpty(val)) || (!isEmpty(val) && data.modalSearchVal !== val)) {
        data.modalSearchVal = val
        data.refreshModalTable++;
      }
    }

    return {
      ...toRefs(data),
      loadData,
      handleAction,
      handleAction,
      setSelectedRows,
      userImportTableCols,
      userPermissionGroups,
      handleAddUpdate,
      nonProjectUsers,
      roleOptions,
      setPermissionGroup,
      removeUser,
      searchModalData
    };
  },
};
</script>

<style scoped>
::v-deep(div .multiselect__option--selected::before) {
  color: #675322 !important
}

::v-deep(.modal-card-body .o-chk) {
  display: block !important
}
</style>